/* eslint-disable dot-notation */
/* eslint-disable no-plusplus */
/* eslint-disable no-restricted-globals */
/* eslint-disable prefer-template */
/* eslint-disable radix */
import {
  Stack,
  Button,
  Container,
  Typography,
  Dialog,
  DialogContent,
  DialogActions,
  DialogTitle,
  LinearProgress,
  FormControl,
  Collapse,
  Snackbar,
  Alert,
  Grid,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  IconButton,
  InputLabel,
  Select,
  MenuItem,
  Box,
  Card,
  CardContent,
  Divider,
  Paper,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  TableContainer,
  Chip
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import LockResetIcon from '@mui/icons-material/LockReset';
import DownloadIcon from '@mui/icons-material/Download';
import CloseIcon from '@mui/icons-material/Close';
import InfoIcon from '@mui/icons-material/Info';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import React, { useEffect, useState } from 'react';
import styled from '@emotion/styled';
import moment from 'moment';
import XLSXS from 'xlsx-js-style';
import { ReactComponent as MastersIcon } from '../media/filter.svg';
import axios from '../axiosConfig';

const useStyles = styled((theme) => ({
  valueCard: {
    backgroundColor: '#f8f9fa',
    borderLeft: '4px solid #219C90',
    borderRadius: '8px',
    height: '100%',
    transition: 'all 0.3s ease',
    '&:hover': {
      transform: 'translateY(-2px)',
      boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
    },
  },
  netValueCard: {
    backgroundColor: '#e3f2fd',
    borderLeft: '4px solid #1976d2',
    borderRadius: '8px',
    height: '100%',
    transition: 'all 0.3s ease',
    '&:hover': {
      transform: 'translateY(-2px)',
      boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
    },
  },
  costCard: {
    backgroundColor: '#e8f5e9',
    borderLeft: '4px solid #4caf50',
    borderRadius: '8px',
    height: '100%',
    transition: 'all 0.3s ease',
    '&:hover': {
      transform: 'translateY(-2px)',
      boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
    },
  },
  overheadsCard: {
    backgroundColor: '#fff3e0',
    borderLeft: '4px solid #ff9800',
    borderRadius: '8px',
    height: '100%',
    cursor: 'pointer',
    transition: 'all 0.3s ease',
    '&:hover': {
      backgroundColor: '#ffe0b2',
      transform: 'translateY(-2px)',
      boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
    },
  },
  processCard: {
    backgroundColor: 'white',
    border: '1px solid #e0e0e0',
    borderRadius: '8px',
    height: '100%',
    transition: 'all 0.3s ease',
    '&:hover': {
      boxShadow: '0 4px 12px rgba(0,0,0,0.08)',
    },
  },
}));

const FactoryExpenseReport = () => {
  const token = 'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJldmVudGxpc3QiOlt7IlVzZXJJRCI6IjEiLCJMb2dpbkNvZGUiOiIwMSIsIkxvZ2luTmFtZSI6IkFkbWluIiwiRW1haWxJZCI6ImFkbWluQGdtYWlsLmNvbSIsIlVzZXJUeXBlIjoiQURNSU4ifV0sImlhdCI6MTYzODM1NDczMX0.ZW6zEHIXTxfT-QWEzS6-GuY7bRupf2Jc_tp4fXIRabQ';

  const [apiConfig] = useState({
    companyId: sessionStorage.getItem('CompanyId'),
    unitId: sessionStorage.getItem('factoryID'),
    fiscalYear: sessionStorage.getItem('FiscalYear'),
  });

  const classes = useStyles();
  const currentDate = new Date();
  
  // Month and Year state
  const [selectedMonth, setSelectedMonth] = useState((currentDate.getMonth() + 1).toString());
  const [selectedYear, setSelectedYear] = useState(currentDate.getFullYear().toString());
  
  // Generate months list
  const months = [
    {value: '0', label: 'All'},
    { value: '1', label: 'January' },
    { value: '2', label: 'February' },
    { value: '3', label: 'March' },
    { value: '4', label: 'April' },
    { value: '5', label: 'May' },
    { value: '6', label: 'June' },
    { value: '7', label: 'July' },
    { value: '8', label: 'August' },
    { value: '9', label: 'September' },
    { value: '10', label: 'October' },
    { value: '11', label: 'November' },
    { value: '12', label: 'December' },
  ];
  
  // Generate years list (last 10 years to current year + 1)
  const currentYear = currentDate.getFullYear();
  const years = Array.from({ length: 12 }, (_, i) => {
    const year = currentYear - 5 + i;
    return { value: year.toString(), label: year.toString() };
  });

  const [reportType] = useState('Production');
  const [unitData, setUnitData] = useState([]);
  const [unitSelected, setUnitSelected] = useState({
    Unit_Id: '0',
    Unit_Name: 'All',
  });
  const [filteredData, setFilteredData] = useState([]);

  // Summary state values
  const [summaryData, setSummaryData] = useState({
    totalCMPValue: 0,
    totalOverheads: 0,
    netValue: 0,
    costPerPiece: 0,
    totalOrderQty: 0,
    processBreakdown: {}
  });

  // Process breakdown expanded state
  const [showProcessBreakdown, setShowProcessBreakdown] = useState(false);

  const resetFilters = () => {
    setSelectedMonth((currentDate.getMonth() + 1).toString());
    setSelectedYear(currentDate.getFullYear().toString());
    setUnitSelected({ Unit_Id: '0', Unit_Name: 'All' });
    setFilteredData([]);
    setSummaryData({
      totalCMPValue: 0,
      totalOverheads: 0,
      netValue: 0,
      costPerPiece: 0,
      totalOrderQty: 0,
      processBreakdown: {}
    });
    setShowProcessBreakdown(false);
  };

  // other states
  const [openLoader, setOpenLoader] = useState(false);
  const [showNoResultsSnackbar, setShowNoResultsSnackbar] = useState(false);
  const [noResultsMessage, setNoResultsMessage] = useState('');
  const [expanded, setExpanded] = useState(true);
  const [processData, setProcessData] = useState([]);
  const [selectedProcess, setSelectedProcess] = useState({ ProcessId: 0, ProcessName: 'All' });
  const [processOrder, setProcessOrder] = useState([]);
  const [obProduction, setObProduction] = useState(true);
  
  // Popup states
  const [overheadsPopupOpen, setOverheadsPopupOpen] = useState(false);
  const [popupData, setPopupData] = useState([]);
  const [totalOverheads, setTotalOverheads] = useState(0);

  // API Integration
  useEffect(() => {
    GetAllActiveProductionUnits();
    getAllProcessData();
    GetOneControl();
    getProcessOrder();
  }, []);

  const getAllProcessData = async (processId = 0) => {
    try {
      const userId = sessionStorage.getItem('UserID');
      const res = await axios.instance.get(`/GetAllProcessData/${processId}`, {
        headers: { Authorization: token, 'Content-Type': 'application/json' },
      });
      setProcessData(res.data);
      return res.data;
    } catch (error) {
      console.error('Error fetching process data:', error);
      return [];
    }
  };

  const GetOneControl = async () => {
    setOpenLoader(true);
    try {
      const res = await axios.instance.get(
        `/GetOneControlCenter/${sessionStorage.getItem('factoryID')}/${sessionStorage.getItem('CompanyId')}`,
        {
          headers: { Authorization: token, 'Content-Type': 'application/json' },
        }
      );
      if (res.data.length > 0) {
        res.data.forEach((data) => {
          setObProduction(data.OBProduction === 'Y');
        });
      } else {
        setObProduction(false);
      }
      setOpenLoader(false);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  const handleProcessChange = async (event) => {
    const selectedProcessId = event.target.value;

    if (filteredData.length > 0) {
      const confirmChange = window.confirm(
        'Changing the process will reset the current results, and new results will be loaded based on the selected process.\n\nDo you want to continue?'
      );
      if (!confirmChange) return;
    }

    setFilteredData([]);
    setSummaryData({
      totalCMPValue: 0,
      totalOverheads: 0,
      netValue: 0,
      costPerPiece: 0,
      totalOrderQty: 0,
      processBreakdown: {}
    });
    setShowProcessBreakdown(false);

    if (Number(selectedProcessId) === 0) {
      setSelectedProcess({ ProcessId: 0, ProcessName: 'All' });
      return;
    }

    const selectedProcessObj = processData.find((process) => process.ProcessId.toString() === selectedProcessId);
    setSelectedProcess(selectedProcessObj);
  };

  // get all unit data
  const GetAllActiveProductionUnits = async () => {
    setOpenLoader(true);
    try {
      const res = await axios.instance.get(`/GetAllActiveProductionUnits/${sessionStorage.getItem('UserID')}`, {
        headers: { Authorization: token, 'Content-Type': 'application/json' },
      });
      setUnitData(res.data);
      setOpenLoader(false);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  const applyFilters = async () => {
    if (selectedProcess.ProcessId === '' || selectedProcess === '') {
      setShowNoResultsSnackbar(true);
      setNoResultsMessage('Please Select Process');
      return;
    }
    
    let fromDate;
    let toDate;
    if (selectedMonth === '0') {
      fromDate = moment(`${selectedYear}-01-01`).format('YYYY-MM-DD');
      toDate = moment(`${selectedYear}-12-31`).format('YYYY-MM-DD');
    } else {
      fromDate = moment(`${selectedYear}-${selectedMonth.padStart(2, '0')}-01`).format('YYYY-MM-DD');
      toDate = moment(fromDate).endOf('month').format('YYYY-MM-DD');
    }

    setOpenLoader(true);
    try {
      const res = await axios.instance.post(
        `/GetFactoryExpenseReport`,
        {
          FromDate: fromDate,
          ToDate: toDate,
          styleId: '0',
          StyleDescription: 'All',
          StyleNumber: 'All',
          BuyerId: '0',
          companyId: sessionStorage.getItem('CompanyId'),
          factoryId: unitSelected.Unit_Id,
          processId: selectedProcess.ProcessId,
          ReportType: reportType,
          IsOBProduction: obProduction ? 'Y' : 'N',
          ProcessType: selectedProcess.ProcessName,
          Summary: 'N',
        },
        {
          headers: { Authorization: token, 'Content-Type': 'application/json' },
        }
      );
      setFilteredData(res.data);
      
      // Calculate summary data
      await calculateSummaryData(res.data);
      
      setOpenLoader(false);
      setExpanded(false);
      setShowNoResultsSnackbar(false);
    } catch (error) {
      console.error('Error fetching data:', error);
      setOpenLoader(false);
    }
  };

  const calculateSummaryData = async (data) => {
    if (data.length === 0) {
      setSummaryData({
        totalCMPValue: 0,
        totalOverheads: 0,
        netValue: 0,
        costPerPiece: 0,
        totalOrderQty: 0,
        processBreakdown: {}
      });
      return;
    }

    // Get overheads data
    const overheadsTotal = await getFilteredFactoryExpenseData();
    
    // Calculate process breakdown and totals
    let totalCMPValue = 0;
    let totalOrderQty = 0;
    const processBreakdown = {};

    // Initialize process breakdown
    processOrder.forEach((processName) => {
      processBreakdown[processName] = {
        totalQty: 0,
        totalValue: 0,
        items: []
      };
    });

    data.forEach((item) => {
      // Add order quantity
      totalOrderQty += parseFloat(item.PackingQty) || 0;
      
      // Calculate process values
      processOrder.forEach((processName) => {
        const qty = getProcessQuantity(item, processName);
        const value = getProcessValueNumber(item, processName);
        
        processBreakdown[processName].totalQty += qty;
        processBreakdown[processName].totalValue += value;
        processBreakdown[processName].items.push({
          qty,
          value,
          styleDescription: item.StyleDescription,
          styleNumber: item.StyleNumber
        });
        
        totalCMPValue += value;
      });
    });

    // Calculate cost per piece
    const costPerPiece = totalOrderQty > 0 ? (totalCMPValue + overheadsTotal) / totalOrderQty : 0;

    setSummaryData({
      totalCMPValue,
      totalOverheads: overheadsTotal,
      netValue: totalCMPValue + overheadsTotal,
      costPerPiece,
      totalOrderQty,
      processBreakdown
    });
  };

  const getProcessQuantity = (enquiry, processName) => {
    const quantityMap = {};

    processOrder.forEach((process) => {
      if (process === 'Production') {
        quantityMap[process] = obProduction ? enquiry.DailyProductionQty : enquiry.ProductionQty;
      } else {
        quantityMap[process] = enquiry[`${process}Qty`];
      }
    });

    return parseFloat(quantityMap[processName]) || 0;
  };

  const getProcessValueNumber = (enquiry, processName) => {
    const valueMap = {};

    processOrder.forEach((process) => {
      if (process === 'Production') {
        valueMap[process] = obProduction ? enquiry.DailyProductionVal : enquiry.ProductionVal;
      } else {
        valueMap[process] = enquiry[`${process}Val`];
      }
    });

    const value = valueMap[processName] || 0;
    return typeof value === 'string' 
      ? parseFloat(value.replace(/,/g, '')) || 0
      : parseFloat(value) || 0;
  };

  const getProcessValue = (enquiry, processName) => {
    const value = getProcessValueNumber(enquiry, processName);
    return value.toLocaleString('en-US', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  };

  const getFilteredFactoryExpenseData = async () => {
    try {
      const response = await axios.instance.post('/GetFilteredFactoryExpenseData', 
      { 
        Month: selectedMonth === '0' ? 0 : selectedMonth, 
        YEAR: selectedYear,
        Factory_Unit: unitSelected.Unit_Id === '0' ? 0 : unitSelected.Unit_Id
      }, {
        headers: { 
          Authorization: token, 
          'Content-Type': 'application/json' 
        },
      });
      
      setPopupData(response.data || []);
      
      // Calculate total overheads
      const total = response.data?.reduce(
        (total, item) => total + Number(item.AmountPerMonth || 0),
        0
      ) || 0;
      setTotalOverheads(total);
      
      return total;
    } catch (error) {
      console.error('Error fetching filtered data:', error);
      setPopupData([]);
      setTotalOverheads(0);
      return 0;
    }
  };

  const handleCloseSnackbar = () => {
    setShowNoResultsSnackbar(false);
  };

  const handleExpansion = () => {
    setExpanded((prevExpanded) => !prevExpanded);
  };

 const exportToExcel = () => {
  if (filteredData.length === 0) {
    setShowNoResultsSnackbar(true);
    setNoResultsMessage('No data to export');
    return;
  }

  const wb = XLSXS.utils.book_new();
  createExcelReport(wb);

  const currentDate = moment().format('DD-MM-YYYY');
  const monthName = months.find(m => m.value === selectedMonth)?.label || selectedMonth;
  XLSXS.writeFile(wb, `Factory_Expense_Report_${monthName}_${selectedYear}_${currentDate}.xlsx`);
};

const createExcelReport = (wb) => {
  const excelData = [];

  // 1. Add title row with styling
  excelData.push(['Production Cost Insights']);
  excelData.push([]);

  // 2. Add filter information
  const monthName = months.find(m => m.value === selectedMonth)?.label || selectedMonth;
  excelData.push(['Period:', `${monthName} ${selectedYear}`]);
  excelData.push(['Factory:', unitSelected.Unit_Name]);
  excelData.push(['Generated On:', moment().format('DD-MM-YYYY HH:mm:ss')]);
  excelData.push([]); // Removed Total Records field

  // 3. Add summary section
  excelData.push(['SUMMARY']);
  excelData.push(['Total CMP Value:', summaryData.totalCMPValue]);
  excelData.push(['Total Overheads:', summaryData.totalOverheads]);
  excelData.push(['Net Value:', summaryData.netValue]);
  excelData.push(['Cost Per Piece:', summaryData.costPerPiece]);
  excelData.push(['Total Completed Quantity:', summaryData.totalOrderQty]);
  excelData.push([]);
  excelData.push([]);

  // 4. Create table headers
  const headers = [];
  
  // Add process columns
  processOrder.forEach((process) => {
    headers.push(`${process} Qty`);
    headers.push(`${process} Value`);
  });
  
  // Add summary columns
  headers.push('Total CMP', 'Over Heads', 'Net Value', 'Cost/Pcs');
  excelData.push(headers);

  // 5. Add table data rows
  filteredData.forEach((item) => {
    const row = [];
    
    let rowCMPTotal = 0;
    const completedQty = parseFloat(item.PackingQty) || 1;
    
    // Add process quantities and values
    processOrder.forEach((processName) => {
      const qty = getProcessQuantity(item, processName);
      const value = getProcessValueNumber(item, processName);
      row.push(qty);
      row.push(value);
      rowCMPTotal += value;
    });

    // Calculate summary values for this row
    const overheadsPerItem = totalOverheads / (filteredData.length || 1);
    const netValue = rowCMPTotal + overheadsPerItem;
    const costPerPiece = completedQty > 0 ? netValue / completedQty : 0;

    // Add summary columns
    row.push(rowCMPTotal, overheadsPerItem, netValue, costPerPiece);
    
    excelData.push(row);
  });

  // Add totals row


  const ws = XLSXS.utils.aoa_to_sheet(excelData);
  
  // Apply styling
  applyExcelStyling(ws, excelData, processOrder.length);
  
  // Set column widths
  const colWidths = [];
  const headerRow = excelData[10]; // Header row is now at index 10 (after removing total records)
  
  for (let i = 0; i < headerRow.length; i++) {
    if (i < 2) {
      colWidths.push({ wch: 25 }); // Style Description and Style Number
    } else {
      colWidths.push({ wch: 15 }); // Process and summary columns
    }
  }
  ws['!cols'] = colWidths;

  XLSXS.utils.book_append_sheet(wb, ws, 'Production Cost Insights');
};

const applyExcelStyling = (ws, data, processCount) => {
  const range = XLSXS.utils.decode_range(ws['!ref']);
  
  // Define colors
  const colors = {
    titleBg: 'FF219C90', // Green/Teal
    summaryBg: 'FFE3F2FD', // Light Blue
    headerBg: 'FF134E5E', // Dark Blue
    totalsBg: 'FFF5F5F5', // Light Gray
    valueBg: 'FFFFFFFF', // White
    processHeaderBg: 'FF36BA98', // Medium Green
    positiveValue: 'FF4CAF50', // Green
    negativeValue: 'FFF44336', // Red
    currency: 'FF2196F3', // Blue
  };
  
  // 1. Title styling (Row 1)
  ws['A1'].s = {
    font: { 
      bold: true, 
      sz: 16, 
      color: { rgb: 'FFFFFFFF' } // White text
    },
    alignment: { 
      horizontal: 'center',
      vertical: 'center'
    },
    fill: {
      fgColor: { rgb: colors.titleBg }
    },
    border: {
      top: { style: 'thin', color: { rgb: 'FF0D3B4A' } },
      bottom: { style: 'thin', color: { rgb: 'FF0D3B4A' } },
      left: { style: 'thin', color: { rgb: 'FF0D3B4A' } },
      right: { style: 'thin', color: { rgb: 'FF0D3B4A' } }
    }
  };
  
  // Merge title row across all columns
  ws['!merges'] = ws['!merges'] || [];
  ws['!merges'].push({
    s: { r: 0, c: 0 },
    e: { r: 0, c: range.e.c }
  });
  
  // 2. Filter information rows (Rows 3-6 - removed one row)
  for (let i = 2; i < 6; i++) {
    const cell = XLSXS.utils.encode_cell({ r: i, c: 0 });
    if (ws[cell]) {
      ws[cell].s = {
        font: { bold: true, sz: 11 },
        fill: {
          fgColor: { rgb: 'FFF8F9FA' } // Very light gray
        }
      };
    }
    
    const valueCell = XLSXS.utils.encode_cell({ r: i, c: 1 });
    if (ws[valueCell]) {
      ws[valueCell].s = {
        font: { sz: 11 },
        fill: {
          fgColor: { rgb: 'FFF8F9FA' }
        }
      };
    }
  }
  
  // 3. Summary section (Rows 8-13 - shifted up one row)
  for (let i = 7; i < 13; i++) {
    const cell = XLSXS.utils.encode_cell({ r: i, c: 0 });
    if (ws[cell]) {
      ws[cell].s = {
        font: { bold: true, sz: 11, color: { rgb: 'FF134E5E' } },
        fill: {
          fgColor: { rgb: colors.summaryBg }
        },
        border: {
          top: { style: 'thin', color: { rgb: 'FFBBDEFB' } },
          bottom: { style: 'thin', color: { rgb: 'FFBBDEFB' } },
          left: { style: 'thin', color: { rgb: 'FFBBDEFB' } },
          right: { style: 'thin', color: { rgb: 'FFBBDEFB' } }
        }
      };
    }
    
    const valueCell = XLSXS.utils.encode_cell({ r: i, c: 1 });
    if (ws[valueCell]) {
      ws[valueCell].s = {
        font: { sz: 11 },
        fill: {
          fgColor: { rgb: colors.summaryBg }
        },
        border: {
          top: { style: 'thin', color: { rgb: 'FFBBDEFB' } },
          bottom: { style: 'thin', color: { rgb: 'FFBBDEFB' } },
          left: { style: 'thin', color: { rgb: 'FFBBDEFB' } },
          right: { style: 'thin', color: { rgb: 'FFBBDEFB' } }
        },
        numFmt: i < 12 ? '#,##0.00' : '#,##0' // Adjusted index
      };
    }
  }
  
  // 4. Table header row (Row 15 - shifted up one row)
  const headerRow = 14; // Zero-based index (15th row)
  for (let col = 0; col <= range.e.c; col++) {
    const cellAddress = XLSXS.utils.encode_cell({ r: headerRow, c: col });
    if (ws[cellAddress]) {
      ws[cellAddress].s = {
        font: { 
          bold: true, 
          sz: 11, 
          color: { rgb: 'FFFFFFFF' } // White text
        },
        alignment: { 
          horizontal: 'center',
          vertical: 'center'
        },
        fill: {
          fgColor: { rgb: colors.headerBg }
        },
        border: {
          top: { style: 'medium', color: { rgb: 'FF0D3B4A' } },
          bottom: { style: 'medium', color: { rgb: 'FF0D3B4A' } },
          left: { style: 'thin', color: { rgb: 'FF0D3B4A' } },
          right: { style: 'thin', color: { rgb: 'FF0D3B4A' } }
        }
      };
    }
  }
  
  // 5. Data rows styling
  const dataStartRow = 15; // Shifted up one row
  const dataEndRow = dataStartRow + filteredData.length - 1;
  
  for (let row = dataStartRow; row <= dataEndRow; row++) {
    for (let col = 0; col <= range.e.c; col++) {
      const cellAddress = XLSXS.utils.encode_cell({ r: row, c: col });
      if (ws[cellAddress]) {
        const isEvenRow = row % 2 === 0;
        const bgColor = isEvenRow ? 'FFF8F9FA' : 'FFFFFFFF';
        
        ws[cellAddress].s = {
          font: { sz: 10 },
          fill: {
            fgColor: { rgb: bgColor }
          },
          border: {
            top: { style: 'thin', color: { rgb: 'FFE0E0E0' } },
            bottom: { style: 'thin', color: { rgb: 'FFE0E0E0' } },
            left: { style: 'thin', color: { rgb: 'FFE0E0E0' } },
            right: { style: 'thin', color: { rgb: 'FFE0E0E0' } }
          }
        };
        
        // Apply number formatting for value columns
        if (col >= 2) {
          // Check if this is a value column (odd columns after style info)
          if (col % 2 === 1 || col >= (2 + processCount * 2)) {
            // This is a value column or summary column
            ws[cellAddress].s.numFmt = '#,##0.00';
            
            // Color code based on value type
            if (col >= (2 + processCount * 2)) {
              // Summary columns
              if (col === (2 + processCount * 2)) { // Total CMP
                ws[cellAddress].s.fill.fgColor = { rgb: 'FFE8F5E9' };
                ws[cellAddress].s.font.color = { rgb: colors.positiveValue };
              } else if (col === (2 + processCount * 2 + 1)) { // Over Heads
                ws[cellAddress].s.fill.fgColor = { rgb: 'FFFFF3E0' };
                ws[cellAddress].s.font.color = { rgb: 'FFFF9800' };
              } else if (col === (2 + processCount * 2 + 2)) { // Net Value
                ws[cellAddress].s.fill.fgColor = { rgb: 'FFE3F2FD' };
                ws[cellAddress].s.font.color = { rgb: colors.currency };
              } else if (col === (2 + processCount * 2 + 3)) { // Cost/Pcs
                ws[cellAddress].s.fill.fgColor = { rgb: 'FFF1F8E9' };
                ws[cellAddress].s.font.color = { rgb: colors.positiveValue };
              }
            }
          } else {
            // Quantity columns
            ws[cellAddress].s.numFmt = '#,##0';
          }
        }
      }
    }
  }
  
  // 6. Totals row styling
  if (filteredData.length > 0) {
    const totalsRow = dataEndRow + 1;
    for (let col = 0; col <= range.e.c; col++) {
      const cellAddress = XLSXS.utils.encode_cell({ r: totalsRow, c: col });
      if (ws[cellAddress]) {
        ws[cellAddress].s = {
          font: { 
            bold: true, 
            sz: 11,
            color: col === 0 ? { rgb: 'FF134E5E' } : { rgb: 'FF000000' }
          },
          fill: {
            fgColor: { rgb: colors.totalsBg }
          },
          border: {
            top: { style: 'medium', color: { rgb: 'FF134E5E' } },
            bottom: { style: 'medium', color: { rgb: 'FF134E5E' } },
            left: { style: 'thin', color: { rgb: 'FF134E5E' } },
            right: { style: 'thin', color: { rgb: 'FF134E5E' } }
          }
        };
        
        // Apply number formatting for totals
        if (col >= 2) {
          if (col % 2 === 1 || col >= (2 + processCount * 2)) {
            ws[cellAddress].s.numFmt = '#,##0.00';
          } else {
            ws[cellAddress].s.numFmt = '#,##0';
          }
        }
      }
    }
  }
  
  // 7. Add freeze pane at header row
  ws['!freeze'] = { xSplit: 0, ySplit: dataStartRow, topLeftCell: `A${dataStartRow + 1}` };
  
  // 8. Removed auto filter (no dropdowns on headers)
};


 

  const formatCurrency = (value) => {
    const numValue = parseFloat(value || 0);
    return numValue.toLocaleString('en-US', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  };

  const getFilterInformation = () => {
    const filterInfo = [];
    const monthName = months.find(m => m.value === selectedMonth)?.label || selectedMonth;

    filterInfo.push(`Period: ${monthName} ${selectedYear}`);
    filterInfo.push(`Process: ${selectedProcess.ProcessId === 0 ? 'All Processes' : selectedProcess.ProcessName}`);
    filterInfo.push(`Factory: ${unitSelected.Unit_Name}`);
    filterInfo.push(`Generated On: ${moment().format('DD-MM-YYYY HH:mm:ss')}`);
    filterInfo.push(`Total Records: ${filteredData.length}`);

    return filterInfo;
  };

  const getProcessOrder = async () => {
    try {
      const res = await axios.instance.get('/GetProcessOrder', {
        headers: { Authorization: token, 'Content-Type': 'application/json' },
      });
      const orderedProcessNames = res.data.map((process) => process.ProcessName);
      setProcessOrder(orderedProcessNames);
    } catch (error) {
      console.error('Error fetching process order:', error);
      setProcessOrder(['Cutting', 'Production', 'Ironing', 'Finishing', 'Packing', 'Shipping']);
    }
  };

  const handleOpenOverheadsPopup = async () => {
    if (popupData.length === 0) {
      await getFilteredFactoryExpenseData();
    }
    setOverheadsPopupOpen(true);
  };

  const toggleProcessBreakdown = () => {
    setShowProcessBreakdown(!showProcessBreakdown);
  };

  return (
    <>
      <Container maxWidth={'xl'} sx={{ pt: 2, p: 1 }} elevation={3}>
        <Snackbar
          style={{ marginTop: '45px' }}
          open={showNoResultsSnackbar}
          autoHideDuration={4000}
          anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
          onClose={handleCloseSnackbar}
        >
          <Alert onClose={handleCloseSnackbar} severity="info" variant="filled" sx={{ width: '100%' }}>
            {noResultsMessage}
          </Alert>
        </Snackbar>

        <Grid justifyContent={'space-between'} alignItems={'center'} spacing={2} mb={2}>
          <Typography
            variant="h5"
            p={1}
            boxShadow={1}
            borderColor="#11235A"
            textAlign={'center'}
            borderRadius={2}
            pl={2}
            color="white"
            sx={{
              background: 'linear-gradient(to right, #134e5e, #71b280)',
              boxShadow: 'rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 2px 6px 2px',
            }}
          >
            <Typography variant="h6" color="white" className="font_style1" textAlign={'center'}>
              Production Cost Insights
            </Typography>
          </Typography>
        </Grid>

        {/* filters */}
        <Stack sx={{ border: '1px solid #CDE8E5', borderRadius: 4, my: 2 }}>
          <Accordion
            expanded={expanded}
            onChange={handleExpansion}
            disableGutters
            sx={{ borderTop: 'none', borderColor: 'black', backgroundColor: 'inherit' }}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon style={{ color: '#36BA98' }} />}
              aria-controls="panel1a-content"
              id="panel1a-header"
              sx={{ borderTop: 'none' }}
            >
              <Stack justifyContent={'start'} direction={'row'} alignItems={'center'} p={0} m={0}>
                <IconButton aria-label="ExpandMoreIcon" color="white">
                  <MastersIcon style={{ color: 'white', width: 24, height: 24 }} />
                </IconButton>
                <Typography
                  sx={{
                    color: '#36BA98',
                    '&.active': {
                      color: 'text.primary',
                      bgcolor: 'action.selected',
                      fontWeight: 'fontWeightBold',
                    },
                  }}
                  variant="h6"
                >
                  Filters
                </Typography>
              </Stack>
            </AccordionSummary>

            <AccordionDetails sx={{ borderTop: 'none', py: 0, pb: 2, pl: 3 }}>
              <Stack direction={'column'} justifyContent={'space-between'} spacing={2} my={1}>
                <Stack direction={{ sm: 'row', xs: 'column' }} spacing={1}>
                  <Grid container spacing={2} rowSpacing={2} columnSpacing={2}>
                   
                    {/* Month Selector */}
                    <Grid item xs={12} md={4}>
                      <FormControl fullWidth size="small">
                        <InputLabel>Select Month</InputLabel>
                        <Select
                          value={selectedMonth}
                          label="Select Month"
                          onChange={(e) => setSelectedMonth(e.target.value)}
                        >
                          {months.map((month) => (
                            <MenuItem key={month.value} value={month.value}>
                              {month.label}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </Grid>

                    {/* Year Selector */}
                    <Grid item xs={12} md={4}>
                      <FormControl fullWidth size="small">
                        <InputLabel>Select Year</InputLabel>
                        <Select
                          value={selectedYear}
                          label="Select Year"
                          onChange={(e) => setSelectedYear(e.target.value)}
                        >
                          {years.map((year) => (
                            <MenuItem key={year.value} value={year.value}>
                              {year.label}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </Grid>

                    {/* Factory Selector */}
                    <Grid item xs={12} md={4}>
                      <FormControl fullWidth size="small">
                        <InputLabel>Select Factory</InputLabel>
                        <Select
                          value={unitSelected.Unit_Id}
                          label="Select Factory"
                          onChange={(e) => {
                            const selectedUnit = unitData.find(unit => unit.Unit_Id.toString() === e.target.value) || { Unit_Id: '0', Unit_Name: 'All' };
                            setUnitSelected(selectedUnit);
                          }}
                        >
                          <MenuItem value="0">All</MenuItem>
                          {unitData.map((unit) => (
                            <MenuItem key={unit.Unit_Id} value={unit.Unit_Id.toString()}>
                              {unit.Unit_Name}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </Grid>

                    {/* Action Buttons */}
                    <Grid item xs={12} md={12}>
                      <Stack direction={{ xs: 'row' }} spacing={1} justifyContent={'end'}>
                        <Stack direction={'row'} spacing={1}>
                          <Button
                            variant="contained"
                            color="secondary"
                            onClick={() => applyFilters()}
                            startIcon={<FilterAltIcon />}
                            sx={{ boxShadow: 0 }}
                          >
                            Apply Filters
                          </Button>
                          <Button
                            variant="contained"
                            color="warning"
                            onClick={() => resetFilters()}
                            startIcon={<LockResetIcon />}
                            sx={{ boxShadow: 0 }}
                          >
                            Reset
                          </Button>
                          <Button
                            variant="contained"
                            color="success"
                            onClick={exportToExcel}
                            startIcon={<DownloadIcon />}
                            sx={{ boxShadow: 0 }}
                            disabled={filteredData.length === 0}
                          >
                            Export Excel
                          </Button>
                        </Stack>
                      </Stack>
                    </Grid>
                  </Grid>
                </Stack>
              </Stack>
            </AccordionDetails>
          </Accordion>
        </Stack>

        {/* Summary Cards Display */}
        <Collapse in={filteredData.length > 0}>
          <Box sx={{ mt: 3, mb: 4 }}>
            <Typography variant="h6" gutterBottom sx={{ color: '#219C90', fontWeight: 'bold', mb: 2 }}>
              Factory Expense Summary
            </Typography>
            
            <Grid container spacing={3}>
              {/* Total CMP Value Card */}
              <Grid item xs={12} md={3}>
                <Card className={classes.valueCard}>
                  <CardContent>
                    <Typography color="textSecondary" gutterBottom variant="body2">
                      Total CMP Value
                    </Typography>
                    <Typography variant="h5" component="div" sx={{ fontWeight: 'bold', color: '#219C90' }}>
                      {formatCurrency(summaryData.totalCMPValue)}
                    </Typography>
                    <Typography variant="caption" color="textSecondary">
                      Cutting + Making + Packing 
                    </Typography>
                  </CardContent>
                </Card>
              </Grid>

              {/* Over Heads Value Card - Clickable */}
              <Grid item xs={12} md={3}>
                <Card 
                  className={classes.overheadsCard}
                  onClick={handleOpenOverheadsPopup}
                >
                  <CardContent>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                      <Box>
                        <Typography color="textSecondary" gutterBottom variant="body2">
                          Over Heads Value
                        </Typography>
                        <Typography variant="h5" component="div" sx={{ fontWeight: 'bold', color: '#f35622' }}>
                          {formatCurrency(summaryData.totalOverheads)}
                        </Typography>
                        <Typography variant="caption" color="textSecondary">
                          Click to view details
                        </Typography>
                      </Box>
                      <InfoIcon sx={{ color: '#f35622' }} />
                    </Box>
                  </CardContent>
                </Card>
              </Grid>

              {/* Net Value Card */}
              <Grid item xs={12} md={3}>
                <Card className={classes.netValueCard}>
                  <CardContent>
                    <Typography color="textSecondary" gutterBottom variant="body2">
                      Net Value
                    </Typography>
                    <Typography variant="h5" component="div" sx={{ fontWeight: 'bold', color: '#1976d2' }}>
                       {formatCurrency(summaryData.netValue)}
                    </Typography>
                    <Typography variant="caption" color="textSecondary">
                      CMP + Overheads
                    </Typography>
                  </CardContent>
                </Card>
              </Grid>

              {/* Cost Per Piece Card */}
              <Grid item xs={12} md={3}>
                <Card className={classes.costCard}>
                  <CardContent>
                    <Typography color="textSecondary" gutterBottom variant="body2">
                      Cost Per Piece
                    </Typography>
                    <Typography variant="h5" component="div" sx={{ fontWeight: 'bold', color: '#4caf50' }}>
                       {formatCurrency(summaryData.costPerPiece)}
                    </Typography>
                    <Typography variant="caption" color="textSecondary">
                      Net value / Completed Qty
                    </Typography>
                  </CardContent>
                </Card>
              </Grid>
            </Grid>

            {/* Process Breakdown Toggle */}
            {/* <Box sx={{ mt: 4, mb: 2 }}>
              <Button
                variant="outlined"
                onClick={toggleProcessBreakdown}
                endIcon={showProcessBreakdown ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                sx={{ 
                  borderColor: '#219C90',
                  color: '#219C90',
                  '&:hover': {
                    borderColor: '#1976d2',
                    backgroundColor: 'rgba(33, 156, 144, 0.04)'
                  }
                }}
              >
                {showProcessBreakdown ? 'Hide Detailed View' : 'Show Detailed View'}
              </Button>
            </Box> */}

            {/* Process Breakdown Section */}
            {/* <Collapse in={showProcessBreakdown}> */}
              <Box sx={{ mt: 3 }}>
                <Typography variant="h6" gutterBottom sx={{ color: '#219C90', fontWeight: 'bold', mb: 2 }}>
                  Detailed View
                </Typography>

                {/* Detailed Table View */}
                <Box sx={{ mt: 4 }}>
                  <TableContainer component={Paper} sx={{ maxHeight: 400, mt: 2 }}>
                    <Table stickyHeader size="small">
                      <TableHead >
                        <TableRow >
                          {processOrder.map((process) => (
                            <React.Fragment key={process}>
                              <TableCell align="center" sx={{ backgroundColor: '#1db3ac', fontWeight: 'bold',color: 'white' }}>{process} Qty</TableCell>
                              <TableCell align="center" sx={{ backgroundColor: '#1db3ac', fontWeight: 'bold',color: 'white' }}>{process} Value</TableCell>
                            </React.Fragment>
                          ))}
                          <TableCell align="center" sx={{ backgroundColor: '#219C90', color: 'white', fontWeight: 'bold' }}>Total CMP</TableCell>
                          <TableCell align="center" sx={{ backgroundColor: '#f35622', color: 'white', fontWeight: 'bold' }}>Over Heads</TableCell>
                          <TableCell align="center" sx={{ backgroundColor: '#1976d2', color: 'white', fontWeight: 'bold' }}>Net Value</TableCell>
                          <TableCell align="center" sx={{ backgroundColor: '#4caf50', color: 'white', fontWeight: 'bold' }}>Cost/Pcs</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {filteredData.map((item, index) => {
                          let rowCMPTotal = 0;
                          const completedQty = parseFloat(item.PackingQty) || 1;
                          const overheadsPerItem = totalOverheads / (filteredData.length || 1);
                          
                          return (
                            <TableRow key={index} hover>
                              {processOrder.map((processName) => {
                                const qty = getProcessQuantity(item, processName);
                                const value = getProcessValueNumber(item, processName);
                                rowCMPTotal += value;
                                return (
                                  <React.Fragment key={processName}>
                                    <TableCell align="right">{qty.toLocaleString()}</TableCell>
                                    <TableCell align="right"> {formatCurrency(value)}</TableCell>
                                  </React.Fragment>
                                );
                              })}
                              <TableCell align="right" sx={{ fontWeight: 'bold', backgroundColor: '#f0f8f7' }}>
                                {formatCurrency(rowCMPTotal)}
                              </TableCell>
                              <TableCell align="right" sx={{ fontWeight: 'bold', backgroundColor: '#fff3e0' }}>
                                {formatCurrency(overheadsPerItem)}
                              </TableCell>
                              <TableCell align="right" sx={{ fontWeight: 'bold', backgroundColor: '#e3f2fd' }}>
                                {formatCurrency(rowCMPTotal + overheadsPerItem)}
                              </TableCell>
                              <TableCell align="right" sx={{ fontWeight: 'bold', backgroundColor: '#e8f5e9' }}>
                                {formatCurrency((rowCMPTotal + overheadsPerItem) / completedQty)}
                              </TableCell>
                            </TableRow>
                          );
                        })}
                        {/* Totals Row */}
                        
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Box>
              </Box>
            {/* </Collapse> */}

            {/* Additional Information */}
            <Paper sx={{ mt: 3, p: 2, backgroundColor: '#f5f5f5' }}>
              <Grid container spacing={2}>
                <Grid item xs={12} md={4}>
                  <Typography variant="body2" color="textSecondary">
                    <strong>Period:</strong> {months.find(m => m.value === selectedMonth)?.label} {selectedYear}
                  </Typography>
                </Grid>
                <Grid item xs={12} md={4}>
                  <Typography variant="body2" color="textSecondary">
                    <strong>Factory:</strong> {unitSelected.Unit_Name}
                  </Typography>
                </Grid>
                <Grid item xs={12} md={4}>
                  <Typography variant="body2" color="textSecondary">
                    <strong>Total Completed Qty:</strong> {summaryData.totalOrderQty.toLocaleString()}
                  </Typography>
                </Grid>
              </Grid>
            </Paper>
          </Box>
        </Collapse>
      </Container>

      {/* Overheads Details Popup */}
      <Dialog
        open={overheadsPopupOpen}
        onClose={() => setOverheadsPopupOpen(false)}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle
          sx={{
            backgroundColor: '#219C90',
            color: 'white',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
          }}
        >
          <Typography variant="h6" fontWeight="bold">
            Overhead Breakdown
          </Typography>
          <IconButton
            aria-label="close"
            onClick={() => setOverheadsPopupOpen(false)}
            sx={{ color: 'white' }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent sx={{ mt: 2 }}>
          <TableContainer component={Paper} sx={{ maxHeight: 400 }}>
            <Table stickyHeader size="small">
              <TableHead>
                <TableRow>
                  <TableCell sx={{ backgroundColor: '#f5f5f5', fontWeight: 'bold' }}>Cost Description</TableCell>
                  <TableCell align="right" sx={{ backgroundColor: '#f5f5f5', fontWeight: 'bold' }}>Amount/Month </TableCell>
                  <TableCell align="center" sx={{ backgroundColor: '#f5f5f5', fontWeight: 'bold' }}>Month</TableCell>
                  <TableCell align="center" sx={{ backgroundColor: '#f5f5f5', fontWeight: 'bold' }}>Year</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {popupData.length > 0 ? (
                  <>
                    {popupData.map((item, index) => (
                      <TableRow key={index} hover>
                        <TableCell>{item.CostDescription || 'N/A'}</TableCell>
                        <TableCell align="right">{formatCurrency(item.AmountPerMonth)}</TableCell>
                        <TableCell align="center">
                          {months.find(m => m.value === item.Month?.toString())?.label || item.Month || 'N/A'}
                        </TableCell>
                        <TableCell align="center">{item.YEAR || 'N/A'}</TableCell>
                      </TableRow>
                    ))}
                    <TableRow sx={{ backgroundColor: '#e3f2fd' }}>
                      <TableCell colSpan={1} align="right" sx={{ fontWeight: 'bold' }}>
                        Total Overheads:
                      </TableCell>
                      <TableCell align="right" sx={{ fontWeight: 'bold' }}>
                         {formatCurrency(totalOverheads)}
                      </TableCell>
                    </TableRow>
                  </>
                ) : (
                  <TableRow>
                    <TableCell colSpan={4} align="center" sx={{ py: 3 }}>
                      <Typography color="textSecondary">No overheads data available</Typography>
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>

          <Box sx={{ mt: 3, p: 2, backgroundColor: '#f8f9fa', borderRadius: 1 }}>
            <Typography variant="body2" color="textSecondary">
              <strong>Note:</strong> Overheads include all indirect expenses for the selected period. 
              These are added to the CMP value to calculate the net manufacturing cost.
            </Typography>
          </Box>
        </DialogContent>

        <DialogActions sx={{ p: 2 }}>
          <Button 
            onClick={() => setOverheadsPopupOpen(false)} 
            color="primary"
            variant="outlined"
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={openLoader}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        fullWidth
      >
        <LinearProgress />
      </Dialog>
    </>
  );
};

export default FactoryExpenseReport;